export const responseTypes = {
    Json: 'json',
    Text: 'text',
    Blob: 'blob',
    ArrayBuffer: 'arraybuffer',
};
